import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/pricing/types';

import { MD_MEDIA_QUERY } from '~shared/media-query';
import { StyleProps } from './types';
import { getTemplate } from '~pricing/components/DetailsPackagesView/useStyles';

export default createUseStyles(({ spacing, palette, elevation, pricingPalette, packageTheme }: PricingAppTheme) => ({
  AccordionControl: {
    marginBottom: spacing[4],
    '& [role=button]': {
      backgroundColor: palette.background.main,
      '& span:first-child': {
        paddingLeft: spacing[3],
        '& strong': {
          fontSize: 13,
          [MD_MEDIA_QUERY]: {
            fontSize: 16,
          },
        },
      },
    },
    '& ul li > div > div': {
      padding: 0,
    },
  },
  Cell: {
    border: `1px solid ${pricingPalette.colors.pebble}`,
    borderTop: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `0 ${spacing[1]}px`,
    textAlign: 'center',
    [MD_MEDIA_QUERY]: {
      '&:not(:last-child)': {
        borderRight: 'none',
      },
    },
  },
  Highlighted: {
    backgroundColor: ({ packageName }: StyleProps) => (packageName ? packageTheme[packageName].primary : 'transparent'),
    color: pricingPalette.colors.white,
    '& a': {
      color: pricingPalette.colors.white,
    },
  },
  DetailRow: {
    ...getTemplate(),
    fontSize: 13,
    color: pricingPalette.colors.charcoal,
  },
  Feature: {
    padding: spacing[4],
    borderLeft: `1px solid ${pricingPalette.colors.pebble}`,
    borderBottom: `1px solid ${pricingPalette.colors.pebble}`,
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    [MD_MEDIA_QUERY]: {
      borderLeft: 'none',
    },
  },
  Bullet: {
    borderRadius: '100%',
    backgroundColor: ({ packageName }: StyleProps) => (packageName ? packageTheme[packageName].primary : 'none'),
    width: 10,
    height: 10,
    display: 'block',
  },
  BulletInverse: {
    composes: '$Bullet',
    backgroundColor: pricingPalette.colors.white,
  },
  ExpandCollapse: {
    fontSize: 13,
    left: spacing[3],
    backgroundColor: 'transparent',
    color: pricingPalette.colors.link,
    border: 'none',
    borderLeft: `1px solid ${pricingPalette.colors.pebble}`,
    borderRight: `1px solid ${pricingPalette.colors.pebble}`,
    padding: spacing[4],
    width: '100%',
    '&:hover, &:focus': {
      textDecoration: 'none',
    },
    '& svg': {
      marginLeft: 5,
    },
    [MD_MEDIA_QUERY]: {
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      padding: 0,
      border: 'none',
      position: 'sticky',
      top: 190,
      zIndex: elevation.sky,
      margin: [-25, 0, 10, 12],
      width: 'auto',
    },
  },
  TooltipContainer: {
    [MD_MEDIA_QUERY]: {
      position: 'relative',
    },
  },
  TooltipIndicator: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
    fontSize: 13,
    color: 'white',
    borderRadius: '100%',
    backgroundColor: pricingPalette.colors.stone,
    cursor: 'help',
    '&:hover': {
      backgroundColor: pricingPalette.colors.flint,
    },
    '&:hover ~ $Tooltip': {
      display: 'inline-block',
    },
  },
  Tooltip: {
    display: 'none',
    pointerEvents: 'none',
    color: pricingPalette.colors.charcoal,
    cursor: 'auto',
  },
}));
